// extracted by mini-css-extract-plugin
module.exports = {"intro":"style_intro__2HYun","arrow":"style_arrow__3jDRW"};